/** Liens de navigation externes, centralisés pour garder le même comportement
 * dans l'accueil Terrain, la fiche d'intervention et la vue Tournée. */
export interface NavigationPoint {
  address: string;
  latitude?: number | null;
  longitude?: number | null;
}

/**
 * Le numéro que « Appeler » compose, le même sur l'accueil et sur la fiche :
 * le contact sur place s'il existe, sinon le client.
 */
export function callablePhone(visit: { local_contact_phone?: string | null; customer_phone?: string | null }): string | null {
  return visit.local_contact_phone || visit.customer_phone || null;
}

function pointValue(point: NavigationPoint): string {
  return point.latitude !== null && point.latitude !== undefined
    && point.longitude !== null && point.longitude !== undefined
    ? `${point.latitude},${point.longitude}`
    : point.address;
}

export function googleMapsDirectionsUrl(point: NavigationPoint): string {
  const params = new URLSearchParams({
    api: '1',
    destination: pointValue(point),
    travelmode: 'driving',
    dir_action: 'navigate',
    utm_source: 'myequip',
    utm_campaign: 'directions_request',
  });
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}

export function wazeDirectionsUrl(point: NavigationPoint): string {
  const params = new URLSearchParams({
    navigate: 'yes',
    utm_source: 'myequip',
  });
  if (point.latitude !== null && point.latitude !== undefined
    && point.longitude !== null && point.longitude !== undefined) {
    params.set('ll', `${point.latitude},${point.longitude}`);
  } else {
    params.set('q', point.address);
  }
  return `https://waze.com/ul?${params.toString()}`;
}

/** Itinéraire multi-arrêts universel. Trois étapes intermédiaires maximum :
 * c'est la limite documentée des navigateurs mobiles Google Maps. */
export function googleMapsTourUrl(points: NavigationPoint[]): string | null {
  if (points.length === 0) return null;
  if (points.length === 1) return googleMapsDirectionsUrl(points[0]!);
  const params = new URLSearchParams({
    api: '1',
    destination: pointValue(points.at(-1)!),
    travelmode: 'driving',
    dir_action: 'navigate',
    utm_source: 'myequip',
    utm_campaign: 'tour_directions_request',
  });
  const waypoints = points.slice(0, -1).slice(0, 3).map(pointValue);
  if (waypoints.length > 0) params.set('waypoints', waypoints.join('|'));
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}
